import { FC } from "react";
import { ChipProps } from "./types";
import { useChip } from ".";

const Chip: FC<ChipProps> = ({
  label,
  startContent,
  endContent,
  className,
  textClassName,
  color = "brand",
}) => {
  const { chipClass, textClass } = useChip(color, className, textClassName);

  return (
    <div className={chipClass}>
      {startContent}
      <span className={textClass}>{label}</span>
      {endContent}
    </div>
  );
};

export default Chip;
